import React, { memo, useCallback, useState } from 'react';
import { IconChevronLeft24, IconChevronRight24 } from '@app/icons';
import { Button } from '../ui/button';
import { cn } from 'lib/utils';

export interface Props {
  initialPage: number;
  totalPages: number;
  totalItems: number;
  onChange: (page: number) => void;
  className?: string;
}

function Pagination(props: Props) {
  const { initialPage, totalPages, totalItems, onChange, className } = props;
  const [page, setPage] = useState<number>(initialPage);

  const onClickPrev = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();

      if (page > 1) {
        setPage(page - 1);
        onChange(page - 1);
      }
    },
    [onChange, page]
  );

  const onClickNext = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();

      if (page < totalPages) {
        setPage(page + 1);
        onChange(page + 1);
      }
    },
    [onChange, page, totalPages]
  );

  if (!totalPages) {
    return null;
  }

  return (
    <div className={cn('flex items-center justify-end h-12 gap-6', className)}>
      <p className="text-sm text-muted-foreground font-normal m-0">
        Кол-во: {totalItems}
      </p>
      <p className="text-sm text-muted-foreground font-normal m-0">
        Страница: {page}
      </p>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="icon"
          onClick={onClickPrev}
          disabled={page <= 1}
          className="h-8 w-8 border-border hover:bg-muted"
        >
          <IconChevronLeft24 className="h-4 w-4" />
        </Button>
        <Button
          variant="outline"
          size="icon"
          onClick={onClickNext}
          disabled={page >= totalPages}
          className="h-8 w-8 border-border hover:bg-muted"
        >
          <IconChevronRight24 className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}

export default memo(Pagination);
